/**
 * PlayPauseButton
 * 
 * 职责：播放/暂停按钮
 */

import React from 'react';

interface PlayPauseButtonProps {
  isPlaying: boolean;
  disabled: boolean;
  onClick: () => void;
}

export const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  isPlaying,
  disabled,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  };

  return (
    <button
      className="control-button play-pause-button"
      disabled={disabled}
      onClick={handleClick}
      onTouchEnd={handleTouchEnd}
      aria-label={isPlaying ? '暂停' : '播放'}
    >
      {isPlaying ? (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <rect x="6" y="4" width="4" height="16" rx="1"/>
          <rect x="14" y="4" width="4" height="16" rx="1"/>
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M8 5v14l11-7z"/>
        </svg>
      )}
    </button>
  );
};

